import React from 'react';
import { Box, Typography } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';

interface SelectedCaptionDisplayProps {
  fileName: string;
  language: string;
}

const SelectedCaptionDisplay = ({ fileName, language }: SelectedCaptionDisplayProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        p: 2,
        mb: 3,
        backgroundColor: '#f9f9f9',
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
        gap: 2
      }}
    >
      <Box
        sx={{
          backgroundColor: '#ffd700',
          color: '#000',
          borderRadius: '4px',
          p: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '40px',
          height: '40px'
        }}
      >
        <DescriptionIcon sx={{ fontSize: '20px' }} />
      </Box>
      
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="body1"
          sx={{
            fontWeight: '600',
            fontSize: '14px',
            mb: 0.5
          }}
        >
          {fileName}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: '12px',
            color: 'text.secondary',
            fontStyle: 'italic'
          }}
        >
          ({language})
        </Typography>
      </Box>
    </Box>
  );
};

export default SelectedCaptionDisplay;